__turbopack_context__.v({
  "body": "visit-guide-card-module-scss-module__myM93q__body",
  "card": "visit-guide-card-module-scss-module__myM93q__card",
  "heading": "visit-guide-card-module-scss-module__myM93q__heading",
});
